import { capitalize, map } from 'lodash'
import routes, { getRouteFromPathname } from 'shared/routes'

const categories = new Map(map(routes, (route, key) => [route, capitalize(key).replace(/_/g, ' ')]))

export const fromPathname = (pathname: string) => {
    const isStickerDetail = pathname.indexOf('/stickers/') >= 0
    const isStickerSearch = pathname.indexOf('-sticker') >= 0
    const route = getRouteFromPathname(pathname)

    switch (route) {
        case routes.GIF_DETAIL:
            return isStickerDetail ? 'StickerDetail' : 'GIFDetail'
        case routes.SEARCH:
            return isStickerSearch ? 'StickerSearch' : 'GIFSearch'
        case routes.TRENDING:
            return 'Trending GIFs'
        case routes.ERROR_404:
            return '404'
        // all of the below just get captilized
        // we could probably just let this fall through to the
        // default case but good to be explicit
        // in case the default isn't enough we'll get the log
        case routes.UPLOAD:
        case routes.CREATE:
        case routes.CATEGORIES:
        case routes.SETTINGS:
        case routes.FAVORITES:
        case routes.CHANNEL:
        case routes.HOME:
        case routes.TEAM:
        case routes.EXPLORE:
        case routes.LOGIN:
        case routes.JOIN:
        case routes.ARTISTS:
        case routes.APPLY:
        case routes.GIF_VIDEO:
        case routes.PASSWORD_CHANGE:
        case routes.PASSWORD_RESET:
        case routes.VIDEOS:
        case routes.VIDEO_DETAIL:
        case routes.APPS:
        case routes.HOMEBASE:
        case routes.STORY:
        case routes.EDIT_GIFS:
            return categories.get(route)
        default:
            const fallback = route ? categories.get(route) : ''
            console.error(`GA event manager, no pathname match for ${pathname}, using ${fallback}`)
            return fallback
    }
}
